import { useState, useEffect } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { Crown } from 'lucide-react';
import { useNavigate, useLocation } from 'react-router-dom';

const FloatingAssessmentButton = () => {
  const [isVisible, setIsVisible] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => {
      setIsVisible(window.scrollY > 500);
    };

    window.addEventListener('scroll', handleScroll, { passive: true });
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const handleClick = () => {
    if (location.pathname === '/') {
      const element = document.getElementById('investment-assessment');
      if (element) {
        element.scrollIntoView({ behavior: 'smooth' });
      }
    } else {
      navigate('/#investment-assessment');
    }
  };

  return (
    <AnimatePresence>
      {isVisible && (
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          exit={{ opacity: 0, y: 20 }}
          transition={{ duration: 0.3 }}
          className="fixed right-4 md:right-6 bottom-[120px] md:bottom-32 z-40"
        >
          <button
            onClick={handleClick}
            className="flex items-center gap-2 bg-gradient-gold text-cream px-5 py-3 rounded-full shadow-lg shadow-gold/30 hover:opacity-90 transition-opacity"
          >
            <Crown className="h-5 w-5" />
            <span className="font-medium text-sm">Assess</span>
          </button>
        </motion.div>
      )}
    </AnimatePresence>
  );
};

export default FloatingAssessmentButton;
